<template>
  <div class='new'>
     <Nav></Nav>
      <div class="title_border">

          <div class="anci_header_content">
              <div class="article-title">
                  <h2>{{newobj.news_name}}</h2>
              </div>
          </div>
      </div>
      <div class="article">
          <p>{{newobj.author}}</p>
          <img :src="newobj.news_img" alt="">
          <p>{{newobj.news_content}}</p>
      </div>

        <!-- <div class="recod">
      <img src="../assets/image/mat.gif" alt="">
       沪ICP备15014511号 Copyright 2018 © 致源广告 All Reserved
    </div> -->
    <Footer></Footer>
  </div>
</template>

<script>
import Footer from '../components/Footer'
import Nav from '../components/Nav'

export default {
  components: {
    Footer,
    Nav
  },
  data () {
    return {
      newobj: {}
    }
  },
  created () {
    this.cretelist()
  },
  methods: {
    cretelist () {
      const newst = JSON.parse(this.$route.query.newst)
      this.newobj = newst
    }
  }
}
</script>

<style lang="scss" scoped>
.new {
  .header {
    position: fixed;
    width: 100%;
    height: 76px;
    top: 0;
    left: 0;
    z-index: 33;
    background-color: #fff;
    img {
      width: 154px;
      height: 74px;
      cursor: pointer;
      margin-left: 20px;
    }
  }
    .title_border {
      margin-top: 60px;
        .el-breadcrumb {
            margin-left: 30px;
           padding-top: 20px;
        }
    width: 100%;
    background-color: #f8f8f9;
    border-bottom: 1px solid #eee;
    // margin-top: 50px;
    .anci_header_content {
      width: 900px;
    margin: 0 auto;
    padding-bottom: 50px;
    }
    .article-title {
    h2 {
     font-size: 40px;
    line-height: 58px;
    padding-top: 41px;
    padding-bottom: 21px;
    text-align: justify;
    font-weight: 700;
    font-family: "Microsoft Yahei",
        }
      }
    }
    .article {
        width: 1024px;
        margin: 0 auto;
        margin-top: 60px;
        p {
            font-size: 16px;
            margin-top: 20px;
            line-height: 34px;
        }
        img {
            display: inline-block;
            margin-top: 20px;

        }
    }
     .recod {
    margin-top: 20px;
    text-align: center;
    img {
      width: 10px;
      height: 14px;
      display: inline-block;
      vertical-align: middle;
    }
  }
}
</style>
